(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adev-product-media"] && !Shopify.designMode) return;
  try {
    // The existing Slick navigation shows every thumbnail in a scrollable row.
  // Keep those visible controls keyboard-accessible after Slick updates ARIA.
  if (!customElements.get('sln-product-thumbnails')) {
    customElements.define('sln-product-thumbnails', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        const sync = () => this.querySelectorAll('button.apm-ti').forEach(button => {
          if (button.getAttribute('aria-hidden') !== 'false') button.setAttribute('aria-hidden', 'false');
          if (button.tabIndex !== 0) button.tabIndex = 0;
          button.setAttribute('aria-pressed', String(button.classList.contains('slick-current')));
        });
        this.observer = new MutationObserver(sync);
        this.observer.observe(this, {subtree:true,childList:true,attributes:true,attributeFilter:['class','tabindex','aria-hidden']});
        sync();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sln-guarantee-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sln-guarantee-card')) {
    customElements.define('sln-guarantee-card', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('a');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const url = new URL(link.href, location.href);
          if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
          const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
          if (!target) return;
          event.preventDefault();
          history.pushState(null, '', url.hash);
          if (target.matches('details')) target.open = true;
          const focusTarget = target.querySelector('summary') || target;
          focusTarget.focus({preventScroll:true});
          target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }, {signal:this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sln-quantity-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sln-quantity-picker')) {
    customElements.define('sln-quantity-picker', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.input = this.querySelector('[data-sln-quantity]');
        this.details = this.querySelector('details');
        this.trigger = this.querySelector('summary');
        this.variants = JSON.parse(this.querySelector('[data-sln-variants]').textContent);
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency});
        this.savingsMoney = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency,minimumFractionDigits:0,maximumFractionDigits:2});
        this.addEventListener('click', event => {
          const option = event.target.closest('button[data-quantity]');
          if (!option) return;
          this.setQuantity(Number(option.dataset.quantity));
          this.details.open = false;
          this.trigger.focus({preventScroll:true});
          this.dispatchEvent(new CustomEvent('sln:quantity-change', {bubbles:true,detail:{productId:this.dataset.productId,quantity:Number(this.input.value)}}));
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.details.open) {
            this.details.open = false;
            this.trigger.focus({preventScroll:true});
          }
        }, options);
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.details.open = false;
        }, options);
        document.addEventListener('sln:quantity-change', event => {
          if (event.target !== this && event.detail?.productId === this.dataset.productId) this.setQuantity(event.detail.quantity);
        }, options);
        document.addEventListener('variant:change', event => {
          const variant = event.detail?.variant;
          if (!variant || !this.variants.some(item => item.id === variant.id)) return;
          const input = this.form?.querySelector('[name="id"]');
          if (input) input.value = variant.id;
          this.render();
        }, options);
        document.addEventListener('shopify:section:load', () => this.refresh(), options);
        document.addEventListener('sln:offer-ready', () => this.refresh(), options);
        this.refresh();
        if (this.hasAttribute('data-primary')) this.dispatchEvent(new CustomEvent('sln:offer-ready', {bubbles:true}));
      }
      refresh() {
        this.form = document.getElementById(this.dataset.formId);
        this.scope = this.closest('.sln-pdp') || this.closest('.sln-purchase');
        this.primary = document.querySelector('sln-quantity-picker[data-primary][data-product-id="' + this.dataset.productId + '"]');
        const source = this.primary || this;
        const offer = JSON.parse(source.querySelector('[data-sln-offer]').textContent);
        this.tiers = offer.currency === this.dataset.currency ? offer.tiers : [];
        this.setQuantity(Number(this.primary?.querySelector('[data-sln-quantity]')?.value || this.input.value));
      }
      savings(quantity) {
        return this.tiers.reduce((amount, tier) => quantity >= tier.quantity ? Math.max(amount, tier.saving) : amount, 0);
      }
      savingsLabel(amount) {
        return this.dataset.saveTemplate.replace('__amount__', this.savingsMoney.format(amount / 100));
      }
      setQuantity(quantity) {
        this.input.value = Math.max(1, Math.floor(quantity) || 1);
        this.render();
      }
      render() {
        const quantity = Number(this.input.value);
        const saving = this.savings(quantity);
        const quantityLabel = quantity === 5 ? '5+' : String(quantity);
        this.querySelector('[data-sln-quantity-value]').textContent = quantityLabel;
        const savingLabel = this.querySelector('[data-sln-quantity-saving]');
        savingLabel.textContent = saving ? this.savingsLabel(saving) : '';
        savingLabel.hidden = !saving;
        this.trigger.setAttribute('aria-label', this.dataset.quantityLabel + ': ' + quantityLabel + (saving ? ', ' + this.savingsLabel(saving) : ''));
        this.querySelectorAll('button[data-quantity]').forEach(button => {
          const count = Number(button.dataset.quantity);
          const amount = this.savings(count);
          const label = button.querySelector('[data-sln-option-saving]');
          label.hidden = !amount;
          label.textContent = amount ? this.savingsLabel(amount) : '';
          button.setAttribute('aria-pressed', String(count === Math.min(quantity, 5)));
        });
        const primaryForm = this.primary && document.getElementById(this.primary.dataset.formId);
        const variantId = (primaryForm || this.form)?.querySelector('[name="id"]')?.value;
        const variant = this.variants.find(item => String(item.id) === variantId) || this.variants[0];
        if (!variant || !this.form || !this.scope) return;
        this.form.querySelector('[name="id"]').value = variant.id;
        const total = Math.max(0, variant.price * quantity - saving);
        const totalLabel = this.scope.querySelector('[data-sln-total], #n-regprice');
        if (totalLabel) totalLabel.textContent = this.money.format(total / 100);
        const unitPrice = this.scope.querySelector('[data-sln-unit-price]');
        if (unitPrice) unitPrice.textContent = this.money.format(variant.price / 100);
        const button = this.form.querySelector('[type="submit"]');
        if (button) button.disabled = !variant.available;
        const buttonLabel = this.form.querySelector('[data-sln-button-label]');
        if (buttonLabel) buttonLabel.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        const priceWrap = this.form.querySelector('[data-sln-price-wrap]');
        if (priceWrap) priceWrap.hidden = !variant.available;
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
